import { Injectable } from "@angular/core";
import { Action, NgxsAfterBootstrap, Selector, State, StateContext } from "@ngxs/store";
import { UiSchemaCollection } from "@vp/formly/ui-schema-config";
import { take } from "rxjs/operators";
import { UiSchemaApiService } from "../api/ui-schema-api.service";
import { UiSchemaStateModel } from "../models/ui-schema-state";
import * as UiSchemaActions from "./ui-schema.actions";

@State<UiSchemaStateModel>({
  name: "uiSchemaState",
  defaults: {
    uiSchemas: [],
    errors: []
  }
})
@Injectable()
export class UiSchemaState implements NgxsAfterBootstrap {
  constructor(private readonly apiService: UiSchemaApiService) {}

  @Selector()
  public static uiSchemas(state: UiSchemaStateModel) {
    return [...state.uiSchemas];
  }

  @Action(UiSchemaActions.UpdateState)
  update(ctx: StateContext<UiSchemaStateModel>, { state }: UiSchemaActions.UpdateState) {
    return ctx.patchState(state);
  }

  ngxsAfterBootstrap(ctx: StateContext<UiSchemaStateModel>) {
    this.apiService
      .get()
      .pipe(take(1))
      .subscribe((uiSchemas: UiSchemaCollection[]) => {
        ctx.patchState({
          uiSchemas: uiSchemas
        });
      });
  }
}
